import { useMemo } from 'react'
import { useRouter } from 'next/router'
import useShortenCurrentUrl from '@/hooks/useShortenCurrentUrl'
import getFirstQueryString from '@/utils/getFirstQueryString'

export default function useShopLandingLink (landingUrl?: string) {
  const router = useRouter()
  const shortenUrl = useShortenCurrentUrl()
  const { service, broadcastId } = router.query || {}

  return useMemo(() => {
    if (!landingUrl) return '#'
    const serviceId = getFirstQueryString(service)
    const _broadcastId = getFirstQueryString(broadcastId)
    if (serviceId === 'MYSHOP') {
      const linkUrl = new URL(landingUrl)
      linkUrl.searchParams.set('redirectUrl', shortenUrl)
      linkUrl.searchParams.append('utm_source', 'livecommerce')
      linkUrl.searchParams.append('utm_campaign', _broadcastId)
      return linkUrl.toString()
    }
    return landingUrl
  }, [landingUrl, service, broadcastId, shortenUrl])
}
